import { render, staticRenderFns } from "./PromotionsLayout.vue?vue&type=template&id=80a48e7c&scoped=true&"
import script from "./PromotionsLayout.vue?vue&type=script&lang=js&"
export * from "./PromotionsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a48e7c",
  null
  
)

export default component.exports